RivalIQ.module('graph.behaviors', function (behaviors, App, Backbone, Marionette, $, _) {

    'use strict';

    behaviors.Resizes = Marionette.Behavior.extend({
        defaults: {
            debounce: 30,
            handler: 'render',
            viewLifecycleEvent: undefined
        },

        initialize: function (config, view) {
            const me = this;

            const options = me.options;
            const handler = _.bind(view[options.handler], view);
            me.resizeHandler = _.debounce(handler, options.debounce);

            const wrapper = function (fn) {
                return function () {
                    if (fn) {
                        fn.call(view);
                    }

                    me.onViewLifecycleEvent();
                };
            };

            let lifecycleEvent = me.options.viewLifecycleEvent;
            if (!lifecycleEvent) {
                lifecycleEvent = 'onAttach';
                if (view.isLoadingView) {
                    lifecycleEvent = 'onAttachLoaded';
                }
            }

            view[lifecycleEvent] = wrapper(view[lifecycleEvent]);
        },

        onDestroy: function () {
            const me = this;
            me.detachResizeHandler();
        },

        onViewLifecycleEvent: function () {
            const me = this;
            me.detachResizeHandler();
            $(window).on('resize', me.resizeHandler);
        },

        detachResizeHandler: function () {
            const me = this;
            if (me.resizeHandler) {
                $(window).off('resize', me.resizeHandler);
            }
        }
    });

});
